// extracted by mini-css-extract-plugin
export default {"checkout-form":"AdyenForm--checkout-form--jPebq","checkoutForm":"AdyenForm--checkout-form--jPebq"};